import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=3e0741ec"
import script from "../../scripts/pages/Procedure.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/Procedure.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports